import { timeZones } from '../utils/time-zones.mjs';
import '../chunks/index-p4VH55K1.mjs';

async function groupByName() {
    return timeZones.sort().map((tz) => ({ label: tz }));
}

export { groupByName };
